import actions from './actions';

const initState = {
  loading: false,
  message: null,
  buttonLoading: false,
  error: null,
  simplResponseData: {},
  totalData: null,
  show: false
};


export default function authReducer(state = initState, action) {
  switch (action.type) {

    case actions.GET_SIMPL_DATA:
      return {
        ...state,
        loading: true,
      };
    case actions.GET_SIMPL_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        simplResponseData: action.payload.data,
        totalData: action.payload.totalData
      };
    case actions.GET_SIMPL_DATA_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
      };

    default:
      return state;
  }

}
